import { TPageType } from 'shared/types/features';
import { CONTENT } from '../constants';

export const getPageContent = (page: TPageType) => {
  return CONTENT[page] || CONTENT['main'];
};
